/**
 * Removes an inline user content item.
 * @method removeInlineUserContent
 */
const removeInlineUserContent = (inlineUserContent) => {
  inlineUserContent &&
    Object.values(inlineUserContent).forEach((element) => {
      // Removing previous spans may leave messy, separated text nodes that need to be put back together
      element.parentElement.normalize();

      element.remove();
    });
};

export default removeInlineUserContent;
